// OrdersPage.js
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getMyOrders } from '../utils/api';
import { formatDate, ORDER_STATUS_COLORS } from '../utils/helpers';
import { FiPackage } from 'react-icons/fi';

export default function OrdersPage() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getMyOrders().then(r => setOrders(r.data)).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="page-loader"><div className="spinner"/></div>;

  return (
    <div className="container" style={{ padding: '1.5rem 1rem' }}>
      <h1 style={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: '1.5rem' }}>📦 My Orders</h1>
      {orders.length === 0 ? (
        <div style={{ textAlign:'center', padding:'4rem', color:'var(--text-secondary)' }}>
          <FiPackage size={50} style={{ color:'var(--border)', marginBottom:'1rem' }}/>
          <h3>No orders yet</h3>
          <Link to="/products" className="btn btn-primary" style={{marginTop:'1rem'}}>Start Shopping</Link>
        </div>
      ) : (
        <div style={{ display:'flex', flexDirection:'column', gap:'1rem' }}>
          {orders.map(o => {
            const s = ORDER_STATUS_COLORS[o.status] || {};
            return (
              <div key={o._id} className="card" style={{ padding:'1.25rem' }}>
                <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:'0.75rem', flexWrap:'wrap', gap:'0.5rem' }}>
                  <div>
                    <p style={{ fontWeight:700, color:'var(--primary)' }}>#{o.orderNumber}</p>
                    <p style={{ fontSize:'0.8rem', color:'var(--text-muted)' }}>{formatDate(o.createdAt)}</p>
                  </div>
                  <span className="badge" style={{ background:s.bg, color:s.color }}>{s.label}</span>
                </div>
                <div style={{ display:'flex', gap:'0.5rem', marginBottom:'0.75rem', flexWrap:'wrap' }}>
                  {o.items.slice(0,3).map((item,i) => (
                    <img key={i} src={item.image} alt={item.name} style={{ width:44,height:44,borderRadius:8,objectFit:'cover' }} />
                  ))}
                  {o.items.length > 3 && <div style={{ width:44,height:44,borderRadius:8,background:'var(--bg)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'0.75rem',fontWeight:700 }}>+{o.items.length-3}</div>}
                </div>
                <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                  <span style={{ fontWeight:800, color:'var(--accent)' }}>৳{o.totalPrice.toLocaleString()}</span>
                  <Link to={`/orders/${o._id}`} className="btn btn-outline btn-sm">View Details</Link>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
